import { elementExists, addParamToUrl, closeAllDropdowns, getAjaxUrl, removePageFromUrl } from '../Utils';
import { fixTagString } from '../Utils/cleanTagFix';

const TagsController = {
    tagsContainer: '.tags-js',
    desktopSelectedEventClass: 'border-b-4',
    defaultFiltersLabel: 'All',
    filtersLabel: '.dropdown-label-js',

    init(): void {
        if (!elementExists(this.tagsContainer)) return;
        this.setListeners();

        // const initialTag = this.getTagFromUrl();
        // if (initialTag) {
        //     this.setInitialFilter();
        // }
    },

    setListeners(): void {
        const filters: NodeListOf<Element> = document.querySelectorAll(".tag-filter-js");
        filters.forEach((link: Element) => {
            link.addEventListener('click', (ev: Event) => this.clickFilterHandler(ev, filters));
        });
    },

    clickFilterHandler(ev: Event, filters: NodeListOf<Element>): void {
        ev.preventDefault();
        const target = ev.target as HTMLElement;
        const label: string | null = target.textContent;
        const slug: string | null = target.getAttribute('data-slug');
        if (label) {
            this.setActiveFilter(filters, slug);
            this.updateMobileFilterLabel(slug, label);
            this.filterTags(slug);
        }
    },

    setActiveFilter(filters: NodeListOf<Element>, slug: string): void {
        filters.forEach((link: Element) => {
            const itemSlug = link.getAttribute('data-slug');
            const parentElement = link.parentElement;
            
            if (link.classList.contains('desktop-js') && parentElement) {
                parentElement.classList.toggle(this.desktopSelectedEventClass, itemSlug === slug);
            } else if (link.classList.contains('mobile-js')) {
                link.classList.toggle('selected', itemSlug === slug);
            }
        });
        closeAllDropdowns();
    },

    setInitialFilter():void {
        let initialFilter = document.getElementsByClassName(this.desktopSelectedEventClass)[0].children[0];
        const event = new Event("click");
        initialFilter.dispatchEvent(event);
    },
    

    updateMobileFilterLabel(slug: string, label: string): void {
        const dropdownLabelElement: HTMLElement | null = document.querySelector(this.filtersLabel);
        if (!dropdownLabelElement) return;
        dropdownLabelElement.textContent = slug === '' ? this.defaultFiltersLabel : label;
    },

    filterTags(slug: string): void {
        const tag: string = this.getTagFromUrl();
        if (!tag) return;
        
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        searchParams.delete('pag'); // Remove the "page" parameter if it exists
        url.search = searchParams.toString();
        
        this.updateUrl(url, slug);
        this.fetchFilteredTags(slug, tag);
    },

    updateUrl(url, newPostType) {
        url.searchParams.set('postType', newPostType);
        const urlWithoutPage = removePageFromUrl(url);
        window.history.pushState({}, '', urlWithoutPage.toString());
    },

    getTagFromUrl(): string {
        const url = new URL(window.location.href);
        return url.searchParams.get('tag') ?? '';
    },

    fetchFilteredTags(content_type, tag) {
        tag = fixTagString(tag);
        let data = new FormData();
        data.append('action', 'filter_tags_by_content_type');
        data.append('content_type', content_type);
        data.append('tag_slug', tag);
        data.append('base_url', window.location.href);
        fetch(getAjaxUrl(), {
            method: 'POST',
            body: data
        }).then(response => response.json())
            .then(data => {
                const { content, resultsInfo, postCounts } = data;
                const contentArea = document.getElementById('content-area');
                if (contentArea) contentArea.innerHTML = content;

                const resultsInfoArea = document.getElementById('results-info-js');
                if (resultsInfoArea) resultsInfoArea.innerHTML = resultsInfo;

                if (postCounts) {
                    Object.keys(postCounts).forEach(postType => {
                        const spanElement = document.querySelector(`.results-number-js[data-slug="${postType}"]`);
                        if (spanElement) {
                            spanElement.textContent = ` (${postCounts[postType]})`;
                        }
                    });

                    const allSpanElement = document.querySelector('.results-number-js[data-slug=""]');
                    if (allSpanElement) {
                        const totalCount = Object.values(postCounts).reduce((total, count) => total + count, 0);
                        allSpanElement.textContent = ` (${totalCount})`;
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

}

export default TagsController;
